import { useEffect, useRef, useState } from 'react';

const team = [
  {
    name: 'Dr. Eric Paulino',
    oab: 'OAB/PR 114.728',
    role: 'Sócio – Direito Empresarial & Tributário',
    bio: 'Advogado com atuação estratégica em direito empresarial, contratos e setor público. Atua com reestruturação de empresas, planejamento tributário e agronegócio, unindo formação acadêmica sólida à prática em gestão de crises e soluções jurídicas complexas.',
    areas: ['Direito Empresarial', 'Contratos', 'Agronegócio', 'Tributário'],
    img: 'https://storage.readdy-site.link/project_files/e8b4defa-f953-4dea-a495-457cf6d0c478/20003e45-6947-45f8-8b82-5b94ed809ee8_Dr-Eric-Paulino.jpeg?v=45e40f69f49ab94f6f169de283de5fe5',
  },
  {
    name: 'Dra. Raphaela Russi',
    oab: 'OAB/PR 42.178',
    role: 'Sócia – Assessoria Empresarial',
    bio: 'Advogada com mais de 15 anos de experiência em assessoria empresarial. Especialista em prevenção de litígios, estruturação patrimonial e holdings familiares, com atuação estratégica e foco em resultados sustentáveis.',
    areas: ['Holdings Familiares', 'Estruturação Patrimonial', 'Litígios', 'Planejamento'],
    img: 'https://storage.readdy-site.link/project_files/e8b4defa-f953-4dea-a495-457cf6d0c478/e43745ee-513a-464d-a05a-1686f76ed4f0_Dra.-Rafaela-Russi.jpeg?v=902f6f8874b19df731030138e4920c55',
  },
  {
    name: 'Dra. Gabriela Kaluzny',
    oab: 'OAB/PR 106.245',
    role: 'Sócia – Planejamento Patrimonial & Leilões',
    bio: 'Advogada com foco em planejamento patrimonial, sucessório e holdings familiares. Atua também em leilões judiciais, oferecendo segurança jurídica e visão estratégica para alavancagem de patrimônio.',
    areas: ['Leilões Judiciais', 'Sucessão', 'Holdings', 'Patrimônio'],
    img: 'https://storage.readdy-site.link/project_files/e8b4defa-f953-4dea-a495-457cf6d0c478/2f8ca1c1-0543-461a-9626-f65bcc7db51c_Dra-Gabriela-Kaluzny.jpeg?v=8130e7797380f483993a531428d7812e',
  },
];

function TeamCard({ member, i, visible }: { member: typeof team[0]; i: number; visible: boolean }) {
  return (
    <div
      className="group relative overflow-hidden flex flex-col"
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(32px)',
        transition: `opacity 0.7s ease ${i * 150}ms, transform 0.7s ease ${i * 150}ms`,
      }}
    >
      {/* Image container */}
      <div
        className="relative w-full h-[420px] overflow-hidden bg-kpr-dark flex-shrink-0"
        style={{
          backgroundImage: `url('${member.img}')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center 10%',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-t from-kpr-dark/90 via-kpr-dark/10 to-transparent" />
        <div className="absolute top-5 right-5 bg-kpr-gold text-kpr-dark text-[10px] font-semibold px-3 py-1.5 tracking-wider">
          {member.oab}
        </div>
        <div className="absolute bottom-5 left-6 right-6">
          <h3 className="font-serif text-white text-2xl font-light mb-0.5">{member.name}</h3>
          <div className="text-kpr-gold text-xs tracking-wider uppercase font-medium">{member.role}</div>
        </div>
      </div>

      {/* Content */}
      <div className="bg-white p-6 border border-kpr-light border-t-0 group-hover:border-kpr-gold/20 transition-colors duration-300 flex flex-col flex-1">
        <p className="text-kpr-gray text-sm leading-relaxed mb-5 font-light flex-1">{member.bio}</p>
        <div className="flex flex-wrap gap-2">
          {member.areas.map((area) => (
            <span
              key={area}
              className="text-[11px] text-kpr-dark border border-kpr-light px-3 py-1 tracking-wide font-medium"
            >
              {area}
            </span>
          ))}
        </div>
      </div>

      <div className="absolute top-0 left-0 w-0.5 h-0 bg-kpr-gold group-hover:h-full transition-all duration-500" />
    </div>
  );
}

function MobileCarousel({ visible }: { visible: boolean }) {
  const [current, setCurrent] = useState(0);
  const touchStartX = useRef<number | null>(null);
  const touchEndX = useRef<number | null>(null);

  const prev = () => setCurrent((c) => (c - 1 + team.length) % team.length);
  const next = () => setCurrent((c) => (c + 1) % team.length);

  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e: React.TouchEvent) => {
    touchEndX.current = e.changedTouches[0].clientX;
    if (touchStartX.current !== null && touchEndX.current !== null) {
      const diff = touchStartX.current - touchEndX.current;
      if (Math.abs(diff) > 40) {
        if (diff > 0) next();
        else prev();
      }
    }
  };

  return (
    <div className="relative" onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}>
      {/* Card */}
      <div
        className="transition-all duration-500"
        style={{
          opacity: visible ? 1 : 0,
          transform: visible ? 'translateY(0)' : 'translateY(32px)',
        }}
      >
        <TeamCard member={team[current]} i={0} visible={visible} />
      </div>

      {/* Arrows */}
      <button
        onClick={prev}
        className="absolute top-[210px] -left-3 z-20 w-9 h-9 bg-white border border-kpr-light flex items-center justify-center text-kpr-dark hover:border-kpr-gold hover:text-kpr-gold transition-colors duration-200 cursor-pointer shadow-sm"
        aria-label="Anterior"
      >
        <i className="ri-arrow-left-s-line text-lg w-5 h-5 flex items-center justify-center" />
      </button>
      <button
        onClick={next}
        className="absolute top-[210px] -right-3 z-20 w-9 h-9 bg-white border border-kpr-light flex items-center justify-center text-kpr-dark hover:border-kpr-gold hover:text-kpr-gold transition-colors duration-200 cursor-pointer shadow-sm"
        aria-label="Próximo"
      >
        <i className="ri-arrow-right-s-line text-lg w-5 h-5 flex items-center justify-center" />
      </button>

      {/* Dots */}
      <div className="flex items-center justify-center gap-2 mt-6">
        {team.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className={`transition-all duration-300 cursor-pointer ${
              i === current
                ? 'w-6 h-1.5 bg-kpr-gold'
                : 'w-1.5 h-1.5 bg-kpr-gold/30 hover:bg-kpr-gold/60'
            }`}
            aria-label={`Ir para card ${i + 1}`}
          />
        ))}
      </div>
    </div>
  );
}

export default function Team() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="equipe" className="bg-kpr-cream py-28 lg:py-36" ref={ref}>
      <div className="max-w-7xl mx-auto px-8">
        {/* Header */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-end mb-16">
          <div>
            <div className={`flex items-center gap-4 mb-6 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
              <div className="w-10 h-px bg-kpr-gold" />
              <span className="text-kpr-gold text-xs font-medium tracking-[0.25em] uppercase">Nossa Equipe</span>
            </div>
            <h2 className={`font-serif text-4xl md:text-5xl text-kpr-dark font-light leading-[1.1] transition-all duration-700 delay-100 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
              Profissionais que fazem a diferença
            </h2>
          </div>
          <p className={`text-kpr-gray text-[15px] leading-loose font-light lg:text-right transition-all duration-700 delay-200 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
            Uma equipe de advogados altamente especializados, unidos pela excelência técnica
            e pelo compromisso com os resultados dos nossos clientes.
          </p>
        </div>

        {/* Mobile Carousel */}
        <div className="md:hidden">
          <MobileCarousel visible={visible} />
        </div>

        {/* Desktop Grid */}
        <div className="hidden md:grid md:grid-cols-3 gap-8 items-start">
          {team.map((member, i) => (
            <TeamCard key={member.name} member={member} i={i} visible={visible} />
          ))}
        </div>
      </div>
    </section>
  );
}
